export default __webpack_public_path__ + "static/media/GS.2e6c2148.svg";